import React from 'react';
import { Progress } from 'reactstrap';

const SimpleProgress = ({ value }) => {
  const score = Math.floor(value * 100);

  let color;
  let label;
  if (score > 80) {
    color = 'info';
    label = 'High';
  } else if (score > 50) {
    color = 'warning';
    label = 'Med';
  } else {
    color = 'danger';
    label = 'Low';
  }

  return (
    <div className="mb-3">
      <h6 className="m-0 text-left">
        {`Adherence: ${label}`}
      </h6>
      <div className="mx-4 my-1">
        <Progress
          color={color}
          value={score}
        />
      </div>
    </div>
  );
};

export default SimpleProgress;
